var _defs, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShortUrlIllu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.7 74.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M185.7 199.7h388.2v258.8H185.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    strokeMiterlimit: 0.7,
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 35.1,
    y: 47.8,
    fillOpacity: 0.3,
    strokeLinecap: "round",
    strokeWidth: 0,
    fontFamily: "Monospace",
    fontSize: 10,
    fontWeight: 400,
    paintOrder: "fill markers stroke",
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "Monospace",
      textAlign: "end"
    },
    textAnchor: "end",
    transform: "translate(-36.8 -43.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 47.8,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "https://www.incrediblylong"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 57.9,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "businessname.com/about-"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 68,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "the-company/?tracking_id="), /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 78.1,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "code=002&amp;referral_link_bu"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 88.2,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "executive_branch=12dash"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 98.4,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "second_referreal_seo_poli"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 108.5,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "&amp;why_is_this_so_long_22"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.1,
    y: 118.6,
    fontFamily: "Arial",
    fontWeight: 700,
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    textAnchor: "start"
  }, "_adwords_search_engine_")), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 49.4,
    y: 84.7,
    stroke: "#3a483d",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    strokeWidth: 1.5,
    fontFamily: "Arial",
    fontSize: 12,
    fontWeight: 700,
    paintOrder: "stroke fill markers",
    style: {
      lineHeight: 1,
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "start"
    },
    transform: "translate(-36.8 -43.2)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 49.4,
    y: 84.7
  }, "https://\xE4.dk/short")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortUrlIllu);
export default __webpack_public_path__ + "static/media/shortUrlIllu.05c42ebb388419f4479dda0e8dedb564.svg";
export { ForwardRef as ReactComponent };